import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Services I want to pay for",
  "description": "",
  "published": "2012-08-28T00:00:00.000Z",
  "redirect_from": ["/blog/services-i-want-to-pay-for/swizec/5158"],
  "categories": "Google, OAuth, Online Communities, PayPal, Prediction, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For a while now I've been meaning to write a list of services that I need or want, but haven't found. Some of these probably don't exist, some of them just haven't reached my radar.`}</p>
    <p><img parentName="p" {...{
        "src": "https://distilleryimage11.s3.amazonaws.com/1ae7a724f0c211e1b55e22000a1e9610_6.jpg",
        "alt": "Good Dickens! It's a Wenlock! via miksago",
        "title": "Good Dickens! It's a Wenlock! via miksago"
      }}></img></p>
    <p>{`You can read this list as a sort of manifesto of what I'll get up to in the next few years. Feel free to scavenge for ideas as well. I won't mind, in fact I'll be glad because there's more ideas here than one guy can implement :)`}</p>
    <p>{`In no particular order:`}</p>
    <ul>
      <li parentName="ul">{`A dashboard for the data I collect about myself either implicitly or explicitly`}</li>
      <li parentName="ul">{`A way to consolidate my social profile - at least change the avatar everywhere at once`}</li>
      <li parentName="ul">{`Some way to keep track of all the profiles I have`}</li>
      <li parentName="ul">{`Stripe for Europe`}</li>
      <li parentName="ul">{`When I write, dynamically predict how satisfied my audience will be so I can adjust accordingly`}</li>
      <li parentName="ul">{`Ability to test different contents of a blogpost in regards to different audiences`}</li>
      <li parentName="ul">{`Tell my users how long they are likely to take reading a story`}</li>
      <li parentName="ul">{`Give me N pieces of news/content that will take X amount of time`}</li>
      <li parentName="ul">{`Send funny pictures to friends offline with a single click `}<em parentName="li">{`[`}{`I am SO rebooting this one]`}</em></li>
      <li parentName="ul">{`Pay for small favours by `}<em parentName="li">{`actually`}</em>{` sending a cookie across the world`}</li>
      <li parentName="ul">{`A tool that reminds me to keep in touch with potential clients (some sort of `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Customer_relationship_management",
          "title": "Customer relationship management"
        }}>{`CRM`}</a>{` I guess)`}</li>
      <li parentName="ul">{`According to my personal metrics - give me progress `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Prediction",
          "title": "Prediction"
        }}>{`predictions`}</a>{` with graphs and advice on improving`}</li>
      <li parentName="ul">{`A helper for building good habits so I can just respond to events rather than use my own willpower`}</li>
      <li parentName="ul">{`Unified way of dealing with all the apps/services that have my CreditCard or `}<a parentName="li" {...{
          "href": "http://paypal.com",
          "title": "PayPal"
        }}>{`PayPal`}</a>{` info`}</li>
      <li parentName="ul">{`Unified directory of everyone with `}<a parentName="li" {...{
          "href": "http://oauth.net",
          "title": "OAuth"
        }}>{`OAuth`}</a>{` access to any of my accounts`}</li>
      <li parentName="ul">{`Remind me to unfollow/unfriend people before the task gets too daunting`}</li>
      <li parentName="ul">{`Some unified way of dealing with all the services I might need like plumbers, sysadmins and food delivery`}</li>
      <li parentName="ul">{`Remind me to eat according to a schedule`}</li>
      <li parentName="ul">{`Create a diet for me `}<em parentName="li">{`and`}</em>{` make sure the ingredients are always in the fridge`}</li>
    </ul>
    <p>{`While nothing revolutionary, this is a list of projects that deal with the fact that I'm almost as lazy as I am forgetful. Most of all, the proposed services are about `}<em parentName="p">{`predicting`}</em>{` rather than reacting. I don't want to react to a problem, I want to predict I'm going to have a problem `}<strong parentName="p">{`while I still have time to fix it!`}</strong></p>
    <p>{`With the piles of data available, computers are better at making these predictions than I am.`}</p>
    <p><img parentName="p" {...{
        "src": "/af5db09e39ca35d8930b4e59962e09e5/wp-content-uploads-2012-05-machinelearning.gif",
        "alt": "Machine Learning",
        "title": "Machine Learning"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tbray.org/ongoing/When/201x/2012/07/28/Oauth2-dead"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_27_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.tbray.org/ongoing/When/201x/2012/07/28/Oauth2-dead"
        }}>{`On the Deadness of OAuth 2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.totango.com/2012/08/top-5-quotes-from-crm-evolution-day-2/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_74_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.totango.com/2012/08/top-5-quotes-from-crm-evolution-day-2/"
        }}>{`Top 5 Quotes from CRM Evolution Day 2`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.premierlinedirect.co.uk/knowledge/insurance-news/small_business_insurance_holders_should_implement_crm_systems"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_63_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.premierlinedirect.co.uk/knowledge/insurance-news/small_business_insurance_holders_should_implement_crm_systems"
        }}>{`Small business insurance holders 'should implement CRM systems'`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://java.dzone.com/articles/oauth-and-api-providers-come"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_91_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://java.dzone.com/articles/oauth-and-api-providers-come"
        }}>{`OAuth and API Providers: Come on guys...`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=e59fd7e1-ee18-4181-a1f7-083ce46412fc",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      